import React from 'react'
import { BsInstagram,BsYoutube, BsTwitter, BsFacebook } from 'react-icons/bs'
import {FaPinterestP } from 'react-icons/fa'


function Footer() {
    return (
    <div className=''>
            <div className='flex justify-center items-center py-2'>
                <h2>Follow Disney on</h2>
            </div>
            <div className='flex justify-center items-center '>
                 <div  className='p-4'>
                 <a
                 href="https://www.facebook.com/DisneyinAfrica/?brand_redir=250256588852"
              target="_blank"
              rel="noopener noreferrer"
              
              
                    >
       
        <BsFacebook />
                </a>
                
                </div>
                
                 
                <div  className='p-4'>
                 <a
                 href="https://www.instagram.com/disneyNL/"
              target="_blank"
              rel="noopener noreferrer"
              
              
                    >
       
        <BsInstagram />
                </a>
                
                </div>
                
                    <div  className='p-4'>
                 <a
                 href="https://twitter.com/DisneyNL"
              target="_blank"
              rel="noopener noreferrer"
              
              
                    >
       
        <BsTwitter/>
                </a>
                
                    </div>
                    <div  className='p-4'>
                 <a
                 href="https://nl.pinterest.com/disneynl/"
              target="_blank"
              rel="noopener noreferrer"
              
              
                    >
       
        <FaPinterestP />
                </a>
                
                    </div>
                <div className='p-4'>
                 <a
                 href="https://www.youtube.com/DisneyNL"
              target="_blank"
              rel="noopener noreferrer"
              
              
                    >
       
                <BsYoutube />
                </a>
                
            </div>
                    
                
            </div>

            <div className='flex justify-center items-center'>
                <h2 className='font-[Pacifico,cursive] text-3xl'>Disney</h2>
            </div>
                 
                
           
           
        <div className='flex justify-center items-center w-[100%] max-w-[100%]  flex-wrap text-[12px] py-6 '>
     
      <a
        href="https://support.disney.com/hc/nl"
        target="_blank"
                    rel="noopener noreferrer"
            className='p-2
            hover:text-blue-500'
      >
       
        Need help?
      </a>
      <a
        href="https://www.disney.nl/site-kaart"
        target="_blank"
                    rel="noopener noreferrer"
            className='p-2
            hover:text-blue-500'
      >
        Site map
      </a>
      <a
        href="https://disneytermsofuse.com/dutch-netherlands/"
        target="_blank"
                    rel="noopener noreferrer"
                     className='p-2 hover:text-blue-500'
      >
        Terms of use
      </a>
      <a
        href="https://privacy.thewaltdisneycompany.com/nl/privacybeleid/privacybeleid-2/"
        target="_blank"
                    rel="noopener noreferrer"
                     className='p-2 hover:text-blue-500'
      >
       
        European Peivacy Regulation
      </a>
      <a
        href="https://privacy.thewaltdisneycompany.com/nl/privacybeleid/"
        target="_blank"
                    rel="noopener noreferrer"
                     className='p-2 hover:text-blue-500'
      >
       
        Privacy Policy
      </a>

      <a
        href="https://privacy.thewaltdisneycompany.com/nl/privacybeleid/cookiesbeleid/"
        target="_blank"
                    rel="noopener noreferrer"
                     className='p-2 hover:text-blue-500'
      >
        Cookie Policy
      </a>

      <a
        href="https://www.disney.nl/films/strange-world#show-cookie-manager"
        target="_blank"
                    rel="noopener noreferrer"
                     className='p-2 hover:text-blue-500'
      >
        Manage settings
      </a>

      <a
        href={`https://preferences-mgr.truste.com/?pid=disney01&aid=disneyemea01&type=Disneyemea`}
        target="_blank"
                    rel="noopener noreferrer"
                     className='p-2 hover:text-blue-500'
      >
        Advertisement
      </a>

      <a
        href="https://www.disney.nl/over-ons"
        target="_blank"
                  rel="noopener noreferrer"
                  className='p-2 hover:text-blue-500'
      >
        About us
      </a>

      <a
        href="https://thewaltdisneycompany.eu/"
        target="_blank"
                    rel="noopener noreferrer"
                     className='p-2 hover:text-blue-500'
      >
        The Walt Disney Company
      </a>
         </div> 
    </div>
    
  )
}

export default Footer
